import React from 'react';
import List from 'containers/rest/List';
import { Comment, Tag } from 'antd';
import { formatDateTime } from 'utils/textUtils';
import { useSelector } from 'react-redux';

const CommentItem = ({ record }) => {
  const user = useSelector((state) => state.auth.data);
  return (
    <Comment
      className="html-content"
      style={{ padding: '0px 20px', width: 'auto' }}
      datetime={`${formatDateTime(record?.createdAt)} `}
      content={<div dangerouslySetInnerHTML={{ __html: record?.content }} />}
      author={
        <div>
          {record?.userId === user.id ? (
            <Tag color="green">{user?.customer?.displayName}</Tag>
          ) : (
            <Tag color="#F47D25">LUCAS</Tag>
          )}
        </div>
      }
    />
  );
};

const CommentsList = (props) => (
  <List noCardWrapper isUpdateRoute={false} {...props} resource="comments">
    <CommentItem />
  </List>
);

CommentsList.propTypes = {};

export default CommentsList;
